namespace TabAurous.ECommerce {
    export interface ReceiptRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        SuffixPrefixId?: number;
        Date?: string;
        RefNo?: string;
        RefDate?: string;
        EnteredBy?: string;
        LedgerId?: number;
        POSCustomerId?: number;
        LedgerName?: string;
        IsAdvance?: boolean;
        TotalAmount?: number;
        Narration?: string;
        VoucherTypeId?: number;
        RefTransId?: number;
        RefVoucherId?: number;
        UserId?: number;
        FinancialYearId?: number;
        CurrencyId?: number;
        ExchangeRate?: number;
        CompanyId?: number;
        TaxLedgerId?: number;
        KnockOffTotal?: number;
        ReceiptDetails?: ReceiptDetailsRow[];
        PartyBalance?: Finance.PartyBalanceRow[];
        OrderVoucherNo?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ReceiptRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'ECommerce.Receipt';
        export const deletePermission = 'EComm:ECommSales:Delete';
        export const insertPermission = 'EComm:ECommSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSales:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            SuffixPrefixId = "SuffixPrefixId",
            Date = "Date",
            RefNo = "RefNo",
            RefDate = "RefDate",
            EnteredBy = "EnteredBy",
            LedgerId = "LedgerId",
            POSCustomerId = "POSCustomerId",
            LedgerName = "LedgerName",
            IsAdvance = "IsAdvance",
            TotalAmount = "TotalAmount",
            Narration = "Narration",
            VoucherTypeId = "VoucherTypeId",
            RefTransId = "RefTransId",
            RefVoucherId = "RefVoucherId",
            UserId = "UserId",
            FinancialYearId = "FinancialYearId",
            CurrencyId = "CurrencyId",
            ExchangeRate = "ExchangeRate",
            CompanyId = "CompanyId",
            TaxLedgerId = "TaxLedgerId",
            KnockOffTotal = "KnockOffTotal",
            ReceiptDetails = "ReceiptDetails",
            PartyBalance = "PartyBalance",
            OrderVoucherNo = "OrderVoucherNo",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
